module.exports = __webpack_public_path__ + "static/media/App.b414f292.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 778
// module chunks = 1